import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-edit-data-type",
  templateUrl: "./edit-data-type.component.html",
  styleUrls: ["./edit-data-type.component.scss"],
})
export class EditDataTypeComponent {
  customValue: string = "";
  description: string = "";

  private regex = /^OTHER:([a-zA-Z0-9_]){1,58}$/;

  constructor(
    public dialogRef: MatDialogRef<EditDataTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { dataType: string; element?: any }
  ) {
    if (data?.element) {
      const value = data.element.allowedValue;
      this.customValue = value.startsWith("OTHER:")
        ? value.replace("OTHER:", "")
        : value;
      this.description = data.element.description || "";
    }
  }

get isValid(): boolean {
  const regex = /^OTHER:([a-zA-Z0-9_]){1,58}$/;
  const valueValid = regex.test("OTHER:" + this.customValue);
  // const descriptionValid = this.description && this.description.trim().length > 0;
  return valueValid;
}


  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (!this.isValid) return;

    const result = {
      allowedValue: "OTHER:" + this.customValue,
      description: this.description,
    };
    this.dialogRef.close(result);
  }
}
